<template>
  <div class="wrap">

    <!-- 背景图 -->
    <img class="bg-img"
      src="https://hzwimspic-1251601690.image.myqcloud.com/9e4353e4-3889-4076-9a28-0d448b52faf2_size_1125x792" />

    <!-- 全屏模式下显示的h5导航条 -->
    <div v-if="isFullscreen" class="nav" :style="navStyle">
      <div class="nav-icon back-icon" @click="h5BackClick"></div>
      <div class="nav-title">爱与成长日记</div>
      <div class="nav-icon share-icon" @click="h5ShareClick"></div>
    </div>

    <!-- 日志记录卡片 -->
    <div class="log-card" :style="{ 'margin-top': `${h5NavHeight + 10}px` }">
      <img class="bg-card"
        src="https://hzwimspic-1251601690.image.myqcloud.com/f6f22ef0-8247-4768-ac83-11770c14c752_size_1056x459" alt="">

      <!-- showDateSheet = true -->
      <div class="date-log" @click="showCalendar">
        <span class="date-text">{{ formattedDate.slice(5) }} </span>
        <span class="year">{{ formattedDate.slice(0, 5) }}</span>
        <img src="https://hzwimspic-1251601690.image.myqcloud.com/278218b9-0b3b-4877-9b99-d7c83ab84904_size_24x24"
          alt="">
      </div>

      <div class="service-day">月嫂服务第<span>{{ logInfo.serviceDay }}</span>天</div>

      <div class="service-des">{{ logInfo.serviceDescription }}</div>

      <img class="upload-pic" @click="previewImage"
        :src="logInfo.pics || 'https://hzwimspic-1251601690.image.myqcloud.com/112f5233-64ee-4eac-8d8c-acc6339d118b_size_195x195'"
        alt="" />
    </div>

    <div class="service-help">母婴护理指南</div>

    <div v-if="logInfo.orderPeriodPicUrl" class="service-pic">
      <img :src="logInfo.orderPeriodPicUrl" alt="">
    </div>

    <imagePreview :items="[logInfo.pics]"></imagePreview>

    <van-popup v-model="showDateSheet" position="bottom">
      <van-datetime-picker v-model="dateModel" type="date" title="时间选择" :min-date="startTime" :max-date="endTime"
        :formatter="formatterDatePicker" @confirm="onConfirm" @cancel="onCancel" />
    </van-popup>
  </div>
</template>

<script>
import { queryMemberLogDetail } from '../service'
import dayjs from 'dayjs'
import { DatetimePicker, Popup } from 'vant';
import { getHeaderHeight, setBackBtnHide } from '@/utils'
import imagePreview from '@/components/common/viewImage'
  ; (function () {
    var isPageHide = false
    window.addEventListener('pageshow', function () {
      if (isPageHide) {
        window.location.reload()
      }
    })
    window.addEventListener('pagehide', function () {
      isPageHide = true
    })
  })()
export default {
  data() {
    return {
      logInfo: {},
      showDateSheet: false,
      currentDate: new Date(),
      dateModel: new Date(),
      startTime: new Date(),
      endTime: new Date(),
      isFullscreen: false,
      h5NavHeight: 0, //状态栏+刘海高度
      navBgAlpha: 0,
    }
  },
  components: {
    imagePreview,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  computed: {
    formattedDate() {
      return dayjs(this.currentDate).format('YYYY年MM月DD日')
    },
    navStyle() {
      return {
        height: `${this.h5NavHeight}px`,
        background: `rgba(255,255,255,${this.navBgAlpha})`,
        transition: 'background 0.3s',
        color: '#000'
      }
    }
  },
  created() {
    const selectedDate = window.localStorage.getItem('selectedDate')
    window.localStorage.removeItem('selectedDate')
    this.currentDate = selectedDate ? dayjs(selectedDate) : (this.$route.query.logDate ? dayjs(this.$route.query.logDate) : dayjs())
    this.setNaviConfig()
    this.$$title('爱与成长日记')
  },
  async mounted() {
    this.queryLog()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      // 监听滚动高度，0~80px渐变，超过80px全白
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
      let alpha = scrollY / 80
      if (alpha > 1) alpha = 1
      if (alpha < 0) alpha = 0
      this.navBgAlpha = alpha
    },
    setNaviConfig() {
      const naviType = this.$route.query.naviType
      if (naviType == '4' && isHZWAPP()) {
        /* 仅在孩子王APP中才能全屏模式 */
        window.canGoback = false
        setBackBtnHide()
        this.isFullscreen = true
        const headerHeight = getHeaderHeight() || {
          navHeight: 0,
          statusBarHeight: 0
        }
        this.h5NavHeight = headerHeight.navHeight + headerHeight.statusBarHeight
      }
    },

    h5BackClick() {
      if (this.$$isHZWApp()) {
        window.localjs.gofinish()
      }
    },

    h5ShareClick() {
      window.localjs.invokeAppShare()
    },

    queryLog() {
      this.$$loading(true)
      const logDate = dayjs(this.currentDate).format('YYYY-MM-DD');
      queryMemberLogDetail({ logDate: logDate }).then((res) => {
        this.$$loading(false)
        this.logInfo = res || {}
        this.startTime = new Date(res.confirmHouseholdTime)
        this.endTime = new Date(res.endDate)
      }).catch((err) => {
        this.logInfo = {}
        this.$$loading(false)
        this.$$toast(err)
      })
    },

    showCalendar() {
      location.href = `/v/yuesao-serve/service-calendar?fromuser=1`
    },

    onConfirm(value, index) {
      this.currentDate = value
      this.showDateSheet = false
      this.queryLog()
    },
    onCancel() {
      this.showDateSheet = false
    },

    formatterDatePicker(type, val) {
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },

    previewImage() {
      if (!this.logInfo.pics) {
        return
      }
      this.$store.commit('setPreviewImages', [this.logInfo.pics])
      this.$router.push({ query: { preview: true, index: 0 } })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.wrap {
  position: relative;
  background-color: #f4f4f4;
}

.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: transparent;
  color: #000000;
  z-index: 11;

  .back-icon {
    position: absolute;
    left: rem(18px);
    bottom: rem(20px);
    width: rem(44px);
    height: rem(44px);
    background: url('~@/assets/images/selfphoto/icon_back_black.png') center center/ 100% 100% no-repeat;
  }

  .nav-title {
    position: absolute;
    font-size: rem(34px);
    color: #000000;
    line-height: rem(48px);
    bottom: rem(20px);
    left: 50%;
    transform: translateX(-50%);
  }

  .share-icon {
    position: absolute;
    right: rem(24px);
    bottom: rem(20px);
    width: rem(44px);
    height: rem(44px);
    background: url('https://hzwimspic-1251601690.image.myqcloud.com/e4140ed3-ff0d-4a98-a317-f0804b8904d8_size_88x88') center center/ 100% 100% no-repeat;
  }
}

.bg-img {
  z-index: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: rem(750px);
  height: rem(528px);
}

.log-card {
  position: relative;
  z-index: 10;
  margin-left: rem(25px);
  width: rem(700px);
  height: rem(302px);
  display: flex;
  flex-direction: column;
}

.date-log {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: rem(36px);
  margin-left: rem(32px);
  max-width: rem(320px);

  .date-text {
    color: #000;
    font-size: rem(44px);
    font-weight: 600;
  }

  .year {
    display: block;
    margin-left: rem(12px);
    font-size: rem(28px);
    color: #000;
    font-weight: 600;
  }

  img {
    margin-left: rem(6px);
    width: rem(12px);
    height: rem(12px);
  }
}

.service-day {
  margin-top: rem(10px);
  margin-left: rem(32px);
  color: #121212;
  font-size: rem(26px);

  span {
    color: #ff397e;
    font-size: rem(30px);
  }
}

.service-des {
  margin-top: rem(24px);
  margin-left: rem(32px);
  color: #121212;
  font-size: rem(30px);
  line-height: rem(42px);
  max-width: rem(470px);
  @include tellicpsis;
}

.bg-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.upload-pic {
  position: absolute;
  top: rem(86px);
  right: rem(32px);
  width: rem(130px);
  height: rem(130px);
  border-radius: rem(20px);
}

.service-help {
  position: relative;
  margin: rem(37px) 0 0 rem(32px);
  color: #121212;
  font-size: rem(34px);
  font-weight: 600;
}

.service-pic {
  position: relative;
  height: auto;
  margin: rem(24px);
  border-radius: rem(28px);
  background-color: #fff;
  padding: rem(24px);
  object-fit: contain;
}

/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #ff397e;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: rem(28px);
}

/deep/ .van-ellipsis {
  color: #262626;
  font-size: rem(36px);
}
</style>
